<template>
    <div class="account">
        <a-page-header
        style="border: 1px solid rgb(235, 237, 240);background:#fff;padding:16px 32px"
        :breadcrumb="{ props: { routes } }"
        />
        <div class="account-deatil" style="background:#fff;">
            <a-card>
                <div class="search">
                    <a-button type="primary" style="margin-left:14px" @click="addmodal">添加员工</a-button>
                </div>

                  <a-table
                    :columns="columns"
                    :pagination="pagination"
                    :loading="loading"
                    @change="handleTableChange"
                    :data-source="data"
                >

                <span slot="type" slot-scope="type">
                    <span v-if="type==3">员工</span>
                    <span v-if="type==2">企业</span>
                    <span v-if="type==1">平台</span>
                </span>
                    <span slot="action" slot-scope="text, record">
                        <a-button type="primary" :size="size"  @click="editmodal(index,$event)" :id="record.id"><a-icon type="edit" />编辑</a-button>
                        <a-button type="danger" :size="size" @click="deletemenu(index,$event)" :id="record.id"><a-icon type="delete" />删除</a-button>
                        <!-- <a-button type="" @click="rechargemodal(index,$event)" :id="record.id"  :size="size"><a-icon type="pay-circle" />充值</a-button> -->
                    </span>
                </a-table>
            </a-card>
        </div>


        <!-- 添加 -->
        <a-modal
        class="pwdmodal"
        title="添加员工"
        cancelText="取消"
        okText="确定"
        width="600px"
        :visible="rolemodal"
        :confirm-loading="confirmLoading"
        @ok="adduser"
        @cancel="handleCancel"
        >
            <a-row>
                <a-col :span="5">
                    <label class="required-icon">用户名称：</label>
                </a-col>
                <a-col :span="16">
                   <a-input  v-model="username" placeholder="请输入用户名称"></a-input>
                </a-col>
            </a-row>
            <a-row>
                <a-col :span="5">
                    <label class="required-icon">用户密码：</label>
                </a-col>
                <a-col :span="16">
                   <a-input type="password" v-model="password" placeholder="请输入用户密码"></a-input>
                </a-col>
            </a-row>
            <a-row>
                <a-col :span="5">
                    <label >手机号：</label>
                </a-col>
                <a-col :span="16">
                   <a-input  v-model="phone" placeholder="请输入手机号"></a-input>
                </a-col>
            </a-row>
            <a-row v-if="istype==1">
       
                <a-col :span="5">
                    <label >所属企业：</label>
                </a-col>
                <a-col :span="16">
                   <!-- <a-input  v-model="company" placeholder="请输入公司名称"></a-input> -->
                   <a-select v-model="belong" style="width: 120px" @change="handleChange">
                        <a-select-option  v-for="pd in companylist" :key="pd.id" v-model="pd.id">
                            {{pd.company}}
                        </a-select-option>
                   </a-select>
                </a-col>
            </a-row>
            <a-row>
                <a-col :span="5">
                    <label >真实姓名：</label>
                </a-col>
                <a-col :span="16">
                   <a-input  v-model="real_name" placeholder="请输入真实姓名"></a-input>
                </a-col>
            </a-row>
            <a-row>
                <a-col :span="5">
                    <label>昵称：</label>
                </a-col>
                <a-col :span="16">
                   <a-input  v-model="nick_name" placeholder="请输入用户昵称"></a-input>
                </a-col>
            </a-row>
              <!-- <a-row>
                <a-col :span="5">
                    <label>用户角色：</label>
                </a-col>
                <a-col :span="16">
                   <a-select default-value="all" style="width: 120px" @change="handleChange">
                       <a-select-option value="all" >
                            --请选择--
                        </a-select-option>
                        <a-select-option v-for="(pd,index) in rolelist" :key="index"  v-model="pd.id">
                            {{pd.name}}
                        </a-select-option>
                   </a-select>
                </a-col>
            </a-row> -->
            <!-- <a-row>
                <a-col :span="5">
                    <label class="required-icon">用户类型：</label>
                </a-col>
                <a-col :span="16">
                    <a-radio-group class="ismenu" name="radioGroup" :default-value="3"  @change="editchangeMenu">
                        <a-radio :value="1">
                        平台 
                        </a-radio>
                        <a-radio :value="2">
                        企业
                        </a-radio>
                        <a-radio :value="3">
                        员工
                        </a-radio>
                    </a-radio-group>
                </a-col>
            </a-row> -->

        </a-modal>

        <!-- 充值 -->
         <a-modal
        class="pwdmodal"
        title="充值"
        cancelText="取消"
        okText="确定"
        width="600px"
        :visible="czmodal"
        :confirm-loading="confirmLoading"
        @ok="recharge"
        @cancel="handleCancel"
        >
             <a-row>
                <a-col :span="5">
                    <label class="required-icon">充值金额：</label>
                </a-col>
                <a-col :span="16">
                   <a-input  v-model="money" placeholder="请输入充值金额"></a-input>
                </a-col>
            </a-row>
         </a-modal>

        <!-- 编辑 -->
        <a-modal
        class="pwdmodal"
        title="编辑员工"
        cancelText="取消"
        okText="确定"
        width="600px"
        :visible="editrolemodal"
        :confirm-loading="confirmLoading"
        @ok="editrole"
        @cancel="handleCancel"
        >
            <a-row>
                <a-col :span="5">
                    <label class="required-icon">用户名称：</label>
                </a-col>
                <a-col :span="16">
                   <a-input  v-model="editinfo.username" placeholder="请输入用户名称"></a-input>
                </a-col>
            </a-row>
            <a-row>
                <a-col :span="5">
                    <label class="required-icon">用户密码：</label>
                </a-col>
                <a-col :span="16">
                   <a-input type="password" v-model="editinfo.password" placeholder="不填默认不修改"></a-input>
                </a-col>
            </a-row>
            <a-row v-if="istype==1">
                <a-col :span="5">
                    <label >所属公司：</label>
                </a-col>
                <a-col :span="16">
                   <!-- <a-input  v-model="editinfo.company" placeholder="请输入公司名称"></a-input> -->
                   <a-select v-model="editinfo.belong" style="width: 120px" @change="editChange">
                        <a-select-option  v-for="pd in companylist" :key="pd.id" v-model="pd.id">
                            {{pd.company}}
                        </a-select-option>
                   </a-select>
                </a-col>
            </a-row>
            <a-row>
                <a-col :span="5">
                    <label >手机号：</label>
                </a-col>
                <a-col :span="16">
                   <a-input  v-model="editinfo.phone" placeholder="请输入手机号"></a-input>
                </a-col>
            </a-row>
            <a-row>
                <a-col :span="5">
                    <label >真实姓名：</label>
                </a-col>
                <a-col :span="16">
                   <a-input  v-model="editinfo.real_name" placeholder="请输入真实姓名"></a-input>
                </a-col>
            </a-row>
            <a-row>
                <a-col :span="5">
                    <label>昵称：</label>
                </a-col>
                <a-col :span="16">
                   <a-input  v-model="editinfo.nick_name" placeholder="请输入用户昵称"></a-input>
                </a-col>
            </a-row>
            <!-- <a-row>
                <a-col :span="5">
                    <label>用户角色：</label>
                </a-col>
                <a-col :span="16">

                   <a-select v-model="editinfo.role_id" style="width: 120px" @change="editChange">
                        <a-select-option  v-for="pd in rolelist" :key="pd.id" v-model="pd.id">
                            {{pd.name}}
                        </a-select-option>
                   </a-select>
                </a-col>
            </a-row> -->
            <!-- <a-row>
                <a-col :span="5">
                    <label class="required-icon">用户类型：</label>
                </a-col>
                <a-col :span="16">
                    <a-radio-group class="ismenu" name="radioGroup" :value="editinfo.type"  @change="changeMenu">
                        <a-radio :value="1">
                        平台 
                        </a-radio>
                        <a-radio :value="2">
                        企业
                        </a-radio>
                        <a-radio :value="3">
                        员工
                        </a-radio>
                    </a-radio-group>
                </a-col>
            </a-row> -->
        </a-modal>
    </div>
</template>
    
<script>
import { Modal } from 'ant-design-vue';
const columns = [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
  },
  {
    title: '用户名',
    dataIndex: 'username',
    key: 'username',
  },
//   {
//     title: '用户角色',
//     dataIndex: 'roleids',
//     key: 'roleids',
//   },
{
    title: '用户类型',
    dataIndex: 'type',
    key: 'type',
    scopedSlots: { customRender: 'type' },
  },
  {
    title: '操作',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' },
  },
];

export default {
    data(){
        return{
            routes: [
                {path:'home/main',breadcrumbName: '首页'},
                {breadcrumbName: '员工管理'}
            ],
            data:"",
            columns,
            pagination:{},
            loading:false,
            id:"",
            rolemodal:false,
            confirmLoading:false,
            czmodal:false,
            username:"",
            password:"",
            phone:"",
            real_name:"",
            nick_name:"",
            roleids:"",
            type:3,
            editrolemodal:false,
            rolelist:"",
            editinfo:"",
            size:'small',
            czid:"",
            money:"",
            belong:"请选择",
            istype:"",
            companylist:"",
            currentpagination:"",
        }
    },
    mounted(){
        this.$axios.get('/api/getcompanyList',{
            headers: {
                "appid": this.appSet.appid,
                "appkey": this.appSet.appkey,
                "token":localStorage.getItem('token'),
            }
        }).then((res)=>{
            if(res.data.code==200){
                this.companylist=res.data.data
            }else if(res.data.code==300){
                this.$router.push({path: '/'})
            }else if(res.data.code==401){

            }else{

            }
        })

        this.fetch()

        this.$axios.get('/api/getuserself',{
            headers: {
                "appid": this.appSet.appid,
                "appkey": this.appSet.appkey,
                "token":localStorage.getItem('token'),
            },

        }).then((res)=>{
            if(res.data.code==200){
                this.istype=res.data.data.type
            }else if(res.data.code==300){
                this.$router.push({path: '/'})
            }else if(res.data.code==401){
                this.$message.warning(res.data.msg); 
            }else{
                this.$message.warning(res.data.msg); 
            }
        })

        this.$axios.get('/api/getrolelist',{
            headers: {
                "appid": this.appSet.appid,
                "appkey": this.appSet.appkey,
                "token":localStorage.getItem('token'),
            }
        }).then((res)=>{
            if(res.data.code==200){
                this.rolelist=res.data.data.lists
            }else if(res.data.code==300){
                this.$router.push({path: '/'})
            }else if(res.data.code==401){
                this.$message.warning(res.data.msg); 
            }else{

            }
        })
    },
    methods:{

        handleTableChange(pagination) {
            console.log(pagination);
            const pager = { ...this.pagination };
            pager.current = pagination.current;
            this.pagination = pager;
            this.currentpagination=pagination
            this.fetch({
                limits: pagination.pageSize,
                page: pagination.current,
            });
        },

        fetch(params = {}) {
            this.loading = true;
            this.$axios.get('/api/employee',{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                },
                params:{
                    limits: 10,
                    ...params,
                }
            }).then((res)=>{
                if(res.data.code==200){
                    const pagination = { ...this.pagination };
                    pagination.total = res.data.data.count;
                    this.data=res.data.data.lists
                    this.loading = false;
                    this.pagination = pagination;
                }else if(res.data.code==300){
                    this.$router.push({path: '/'})
                }else if(res.data.code==401){
                    this.$message.warning(res.data.msg); 
                }else{
                    this.$message.warning(res.data.msg); 
                }
            })
        },

        addmodal(){
            this.rolemodal=true
        },
        handleChange(value){
            this.belong=value
        },

        deletemenu(){
            var editid=event.currentTarget.id
            Modal.confirm({
                title: '提示',
                content: '您确定删除此用户吗?',
                okText: '确定',
                okType: 'danger',
                cancelText: '取消',
                onOk:() => {
                    this.handok(editid)
                },
                onCancel() {

                },
            });
        },
        handok(editid){
            var params=new URLSearchParams()
            params.append('id',editid)
            this.$axios.post('/api/deluser',params,{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                }  
            }).then((res)=>{
                if(res.data.code==40014){
                   this.$message.success(res.data.msg); 
                }else if(res.data.code==200){
                    this.$message.success('删除成功');
                    this.fetch({
                        limits: this.currentpagination.pageSize,
                        page: this.currentpagination.current,
                    });
                }else{
                    this.$message.success(res.data.msg);
                }
            })
        },

        editrole(){
            var params=new URLSearchParams()
            params.append('id',this.editinfo.id)
            params.append('username',this.editinfo.username)
            params.append('password',this.editinfo.password)
            params.append('phone',this.editinfo.phone)
            params.append('real_name',this.editinfo.real_name)
            params.append('nick_name',this.editinfo.nick_name)
            // params.append('roleids',this.editinfo.roleids)
            // params.append('type',this.editinfo.type)
            params.append('belong',this.editinfo.belong)
            this.$axios.post('/api/edituser',params,{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.rolemodal=false
                    this.$message.success('编辑成功'); 
                    this.fetch({
                        limits: this.currentpagination.pageSize,
                        page: this.currentpagination.current,
                    });
                    
                }else if(res.data.code==300){
                    this.$router.push({path: '/'})
                }else if(res.data.code==401){
                    this.$message.warning(res.data.msg); 
                }else{
                    this.$message.warning(res.data.msg); 
                }
            })
        },
        editChange(value){
            this.editinfo.belong=value
        },
        editchangeMenu(e){
            this.type=e.target.value;
        },
        changeMenu(e){
            this.editinfo.type=e.target.value;
        },
        handleCancel(){
            this.rolemodal=false
            this.editrolemodal=false
            this.czmodal=false
        },

        rechargemodal(index,event){
            this.czmodal=true
            var editid=event.currentTarget.id
            this.czid=editid
        },
        // 编辑角色
        editmodal(index,event){
            this.editrolemodal=true
            var editid=event.currentTarget.id
            this.id=editid
            this.$axios.get('/api/getuserinfo',{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                },
                params:{
                    id:editid
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.editinfo=res.data.data
                    this.editinfo.password=""
                }else if(res.data.code==300){
                    this.$router.push({path: '/'})
                }else if(res.data.code==401){

                }else{

                }
            })

        },
        recharge(){
            var params=new URLSearchParams()
            params.append('user_id',this.czid)
            params.append('money',this.money)
              this.$axios.post('/api/addmoney',params,{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.czmodal=false
                }
            })
        },
        // 添加角色
        adduser(){
            var params=new URLSearchParams()
            params.append('username',this.username)
            params.append('password',this.password)
            params.append('phone',this.phone)
            params.append('real_name',this.real_name)
            params.append('nick_name',this.nick_name)
            // params.append('roleids',this.roleids)
            params.append('type',3)
            params.append('belong',this.belong)
            this.$axios.post('/api/adduser',params,{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.rolemodal=false
                    this.$message.success('添加成功'); 
                    this.fetch()
                    
                }else if(res.data.code==300){
                    this.$router.push({path: '/'})
                }else if(res.data.code==401){
                    this.$message.success(res.data.msg); 
                }else{
                    this.$message.success(res.data.msg); 
                }
            })
        }
        
    }
}
</script>



// WEBPACK FOOTER //
// src/components/user/staff.vue